import React, { Component} from "react"
import PropTypes from "prop-types"
import styled from 'styled-components'
import PageTransition from 'gatsby-plugin-page-transitions'

import Header from "../components/landing-page-header"

class Layout extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const children = this.props.children
        return (
            <GlobalWrapper>
                <Header />
                <PageTransition
                  transitionTime={1000}
                >
                    <main>{children}</main>
                </PageTransition>
            </GlobalWrapper>
        );
    }
}

const GlobalWrapper = styled.div`
    background-color: #fff;
    position: relative;
    h1 {
        font-family: "Nobel", sans-serif;
        font-weight: 700;
        font-style: normal;
    }
    main {
        padding-top: 0px;
    }
`

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}
  
export default Layout